import { combineReducers } from 'redux';
import dvid from './dvid';

export default combineReducers({
  dvid,
});
